import classNames from 'classnames';
import Preact from 'preact';
import { FooterContent } from '../../content';
import testId from '../../helpers/testId';
import FooterAccordion from '../FooterAccordion';
import FooterBlock from '../FooterBlock';
import FooterText from '../FooterText';

interface Props {
  content: FooterContent;
}

const backgroundColor = (bg: FooterContent['backgroundColor']) => {
  switch (bg) {
    case 'white':
      return 'jg-background--white';

    case 'grey':
      return 'jg-background--white-smoke';
  }
};

const Footer: Preact.FunctionalComponent<Props> = ({ content }) => (
  <footer
    className={classNames(
      testId('footer'),
      'jg-chrome-footer jg-bdt jg-bd--very-light-grey',
      backgroundColor(content.backgroundColor),
    )}
    role="contentinfo"
  >
    {content.siteMap && (
      <div>
        <div className="jg-display-n@lg">
          <FooterAccordion footerMenu={content.siteMap} />
        </div>
        <div className="jg-display-n jg-display-b@lg">
          <FooterText footerMenu={content.siteMap} />
        </div>
      </div>
    )}
    <div className="jg-space-mtmd jg-space-pbsm">
      <FooterBlock
        logo={content.logo}
        copyright={content.copyright}
        secondary={content.secondary}
        findUs={content.findUs}
        social={content.social}
      />
    </div>
  </footer>
);

export default Footer;
